<template>
    <div class="row">
        <div class="span8">
            <label><strong>{{ label }}:</strong></label>                     
            <uploader :max-files="1000" :files="images2 == null ? [] : images2" @files-updated="filesUpdated"></uploader>
        </div>
    </div>
</template>

<script>
    import Uploader from './_uploader.vue'

    export default {
        name: 'block-gallery',
        components: {
            Uploader
        },
        props: {            
            label: {
                type: String,
                required: true
            },
            index: {
                type: Number,
                required: true
            },
            images: {                
                required: true
            }
        },
        watch: {
            images() {
                this.images2 = this.images;
            }
        },
        data() {
            return {
                images2: this.images
            }
        },                
        methods: {
            filesUpdated(files) {
                var self = this;
                
                self.images2 = files;
                
                self.$emit('update:images', self.images2);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// _block-gallery.vue?2b9407d0